export default val => val;

export const ToEuro = price => parseFloat(price).toLocaleString("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 });